import gsap from "gsap";
import { ScrollTrigger } from "gsap/ScrollTrigger";

gsap.registerPlugin(ScrollTrigger);

export function animation() {
  const selectors = [
    ".j-animation",
    ".j-blurup",
    ".j-fadein",
    ".j-fadeleft",
    ".j-faderight",
    ".j-fadeup",
    ".j-slide",
    ".j-slideup",
    ".c-line-animation",
    ".c-scrollShow"
  ];

  selectors.forEach((selector) => {
    const elements = document.querySelectorAll(selector);

    elements.forEach((element) => {
      ScrollTrigger.create({
        trigger: element,
        start: "top 70%",
        once: true,
        onEnter: () => {
          requestAnimationFrame(() => {
            element.classList.add("action");
          });
        }
        // markers: true,
      });
    });
  });

  ScrollTrigger.refresh();
}